import PasswordValidation from "@app/components/Account/PasswordValidation/PasswordValidation.jsx"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { SelectBox } from "@app/components/move2Library/SelectBox/SelectBox"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { setRelation, setTransponder } from "@app/store/actions/coreActions"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useLogin } from "@app/store/service/authService"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetCountries, useGetSalutations, useGetTransponder, useRegister, useStartVerificationByMail } from "@app/store/service/connectorService"
import { emailPattern } from "@app/utils/validations"
import { useToasts } from "@tecreation/funnel-components"
import { ResponseError, useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import ForgotPassword from "../forgotPassword/ForgotPassword"
import "./Account.css"

const Account = () => {
	const [showPasswordValidation, setShowPasswordValidation] = useState(false)
	const [createAccount, setCreateAccount] = useState(false)
	const [accountType, setAccountType] = useState()
	const [forgotPassword, setForgotPassword] = useState(false)
	const [loadTransponder, setLoadTransponder] = useState(false)
	const relation = useSelector(state => state.core.relation)
	const { push, replace } = useCustomNavigation()
	const raiseError = useRaiseError()

	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		setValue,
		reset,
		trigger,
		watch,
	} = useForm({
		defaultValues: {
			salutation: "",
			firstName: "",
			lastName: "",
			surname: "",
			vatNumber: "",
			email: "",
			emailRepeat: "",
			phoneNo: "",
			street: "",
			zipCode: "",
			city: "",
			countryId: "",
			accountType: "privat",
			password: "",
			passwordRepeat: "",
			companyName: "",
		},
	})

	const { addToast } = useToasts()
	const [registerAccount] = useRegister()
	const [login] = useLogin()
	const [startVerificationbyMail] = useStartVerificationByMail()
	const { data: countries } = useGetCountries()
	const { data: salutations } = useGetSalutations()
	const { data: transponder } = useGetTransponder(null, { skip: !loadTransponder })
	const {
		data: {
			forgotPasswordPageTitle,
			myParadiseAccountInfoHeader,
			myParadiseAccountCreateHeader,
			myParadiseAccountLoginHeader,
			buttonSignIn,
			buttonRegister,
			clientTypes,
			placeholderFirstName,
			placeholderLastName,
			placeholderEMail,
			placeholderEMailRepeat,
			placeholderPassword,
			placeholderPasswordRepeat,
			labelSalutation,
			labelCustomerType,
			placeholderCompany,
			placeholderVATNumber,
			errorInputMissingPasswordRepeat,
			errorInputMustBeTheSamePasswordRepeat,
			errorInputPwRequirement,
			errorInputMissingEmail,
			errorInputMissingPassword,
			errorInputMissingFirstName,
			errorInputMissingLastName,
			errorInputInvalidEmail,
			errorInputMissingSalutation,
			errorInputMissingEmailRepeat,
			errorInputMissingCompany,
			errorInputMustBeTheSameEmailRepeat,
			loginPageAccountCreatedText,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	useEffect(() => {
		if (relation) {
			replace("/myParadise/overview")
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [relation])

	useEffect(() => {
		if (countries && getValues().countryId.length === 0) {
			setValue("countryId", "60")
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countries])

	useEffect(() => {
		if (transponder) {
			setTransponder(transponder)
		}
	}, [transponder])

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onRegisterClick = useCallback(async () => {
		handleSubmit(async data => {
			data.genderId = data.salutation
			try {
				let result = await registerAccount(data).unwrap()
				if (result.errorMessage) {
					throw result
				}
				await startVerificationbyMail({ relationToken: result.relationToken, email: result.email }).unwrap()

				setCreateAccount(false)
				addToast({
					variant: "success",
					body: loginPageAccountCreatedText,
				})
			} catch (e) {
				if (e.errorMessage === "wrn.Relation.Unverified") {
					push("/account-not-verified", undefined, { email: data.email, relationToken: e.relationToken })
				} else {
					raiseError(e)
				}
			}
		})()
	})
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const goToOrderPage = useCallback(async () => {
		handleSubmit(async data => {
			try {
				let result = await login({
					email: data.email,
					password: data.password,
				}).unwrap()
				setRelation(result)
				setLoadTransponder(true)
				push("/myParadise/overview", null)
			} catch (e) {
				if (e instanceof ResponseError && e.response.data.errorMessage === "wrn.Relation.Unverified") {
					push("/account-not-verified", undefined, { email: data.email, relationToken: e.response.data.relationToken })
				} else {
					raiseError(e)
				}
			}
		})()
	})

	const handleOnKeyDown = e => {
		if (e.key === "Enter") {
			goToOrderPage()
		}
	}
	return (
		<div className="flex flex-justify-center flex-items-center w-100 createAccount__infoHeader">
			{/* Header here */}
			<div className="createAccount__div">
				{forgotPassword ? (
					<ForgotPassword
						onSuccess={() => {
							setForgotPassword(false)
						}}
					/>
				) : (
					<h4 className="mb-7 createAccount__infoHeader__h4">{myParadiseAccountInfoHeader}</h4>
				)}
				<div className="flex flex-justify-center">
					<div
						className={
							createAccount
								? " w-50 pt-2 pb-2 pl-8 pr-8 f3 clickable color-fg-on-secondary color-bg-secondary flex flex-justify-center"
								: "w-50 pt-2 pb-2 pl-8 pr-8 f3 clickable color-fg-secondary  border-bottom color-border-secondary flex flex-justify-center"
						}
						onClick={() => {
							;(setCreateAccount(true), reset())
						}}
					>
						{myParadiseAccountCreateHeader}
					</div>
					<div
						className={
							!createAccount
								? "w-50 pt-2 pb-2 pl-8 pr-8 f3 clickable color-fg-on-secondary color-bg-secondary flex flex-justify-center"
								: "w-50 pt-2 pb-2 pl-8 pr-8 f3 clickable color-fg-secondary  border-bottom color-border-secondary flex flex-justify-center"
						}
						onClick={() => {
							;(setCreateAccount(false), reset())
						}}
					>
						{myParadiseAccountLoginHeader}
					</div>
				</div>
				{createAccount ? (
					<div className="mt-7">
						<div className="createAccountPage__inputRow createAccountPage__inputRow--1">
							<SelectBox
								classname="createAccountPage__accoutType"
								autocomplete="client"
								formRegister={register("accountType", {
									required: {
										value: true,
										message: errorInputMissingCompany,
									},
								})}
								onChange={e => {
									setAccountType(e.target.value)
								}}
								errors={errors}
								label={labelCustomerType + "*"}
							>
								{clientTypes &&
									clientTypes.map(type => (
										<option key={type.value} value={type.value}>
											{type.name}
										</option>
									))}
							</SelectBox>
						</div>
						<div className="createAccountPage__inputRow createAccountPage__inputRow--3">
							<SelectBox
								classname="w-100"
								autocomplete="salutation"
								formRegister={register("salutation", {
									required: {
										value: true,
										message: errorInputMissingSalutation,
									},
								})}
								errors={errors}
								label={labelSalutation + "*"}
							>
								{salutations &&
									salutations.map(ele => (
										<option key={ele.id} value={ele.id}>
											{ele.salutation}
										</option>
									))}
							</SelectBox>
							<Input
								type="text"
								formRegister={register("firstName", {
									required: {
										value: true,
										message: errorInputMissingFirstName,
									},
								})}
								errors={errors}
								label={placeholderFirstName + "*"}
							/>
							<Input
								type="text"
								formRegister={register("lastName", {
									required: {
										value: true,
										message: errorInputMissingLastName,
									},
								})}
								errors={errors}
								label={placeholderLastName + "*"}
							/>
						</div>
						{accountType === "firma" && (
							<div className="createAccountPage__inputRow createAccountPage__inputRow--2">
								<Input
									type="text"
									formRegister={register("companyName", {
										required: {
											value: true,
											message: errorInputMissingCompany,
										},
									})}
									errors={errors}
									label={placeholderCompany + "*"}
								/>
								<Input
									type="text"
									formRegister={register("vatNumber", {
										required: {
											value: true,
											message: errorInputMissingCompany,
										},
									})}
									errors={errors}
									label={placeholderVATNumber + "*"}
								/>
							</div>
						)}
						<div className="createAccountPage__inputRow createAccountPage__inputRow--3">
							<Input
								type="text"
								formRegister={register("email", {
									required: {
										value: true,
										message: errorInputMissingEmail,
									},
									pattern: {
										value: emailPattern,
										message: errorInputInvalidEmail,
									},
									validate: () => {
										if (getValues("emailRepeat").length) {
											trigger("emailRepeat")
										}
										return true
									},
								})}
								errors={errors}
								label={placeholderEMail + "*"}
							/>
							<Input
								type="text"
								formRegister={register("emailRepeat", {
									required: {
										value: true,
										message: errorInputMissingEmailRepeat,
									},
									validate: {
										equalsEmail: value => value === getValues().email || errorInputMustBeTheSameEmailRepeat,
									},
								})}
								errors={errors}
								label={placeholderEMailRepeat + "*"}
							/>
						</div>
						<div className="createAccountPage__inputRow createAccountPage__inputRow--3">
							<div>
								<Input
									type="password"
									label={placeholderPassword + "*"}
									autocomplete="off"
									onFocusChange={isFocused => {
										setShowPasswordValidation(isFocused)
									}}
									formRegister={register("password", {
										required: {
											value: true,
											message: errorInputMissingPassword,
										},
										validate: () => {
											if (getValues("passwordRepeat").length) {
												trigger("passwordRepeat")
											}
											return true
										},
										pattern: {
											value: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
											message: errorInputPwRequirement,
										},
									})}
								/>
								{showPasswordValidation && (
									<div className="createAccountPage__passwordValidationContainer">
										<PasswordValidation password={watch("password") || ""} />
									</div>
								)}
							</div>
							<div>
								<Input
									type="password"
									label={placeholderPasswordRepeat + "*"}
									autocomplete="off"
									formRegister={register("passwordRepeat", {
										required: {
											value: true,
											message: errorInputMissingPasswordRepeat,
										},
										validate: {
											equalsPassword: value => value === getValues().password || errorInputMustBeTheSamePasswordRepeat,
										},
									})}
									errors={errors}
								/>
							</div>
						</div>
						<div className="mt-4">
							<Button style="secondary" onClick={onRegisterClick}>
								{buttonRegister}
							</Button>
						</div>
					</div>
				) : (
					<div className="mt-7">
						<div className="createAccountPage__inputRow">
							<Input
								type="text"
								formRegister={register("email", {
									required: {
										value: true,
										message: errorInputMissingEmail,
									},
									pattern: {
										value: emailPattern,
										message: errorInputInvalidEmail,
									},
								})}
								errors={errors}
								label={placeholderEMail + "*"}
								onKeyDown={handleOnKeyDown}
							/>
						</div>
						<div className="createAccountPage__inputRow">
							<Input
								type="password"
								formRegister={register("password", {
									required: {
										value: true,
										message: errorInputMissingPassword,
									},
								})}
								errors={errors}
								label={placeholderPassword + "*"}
								onKeyDown={handleOnKeyDown}
							/>
						</div>
						<div className="mt-2">
							<a href="#" onClick={() => setForgotPassword(true)}>
								{forgotPasswordPageTitle}
							</a>
						</div>
						<div className="mt-5">
							<Button onClick={goToOrderPage} style="secondary">
								{buttonSignIn}
							</Button>
						</div>
					</div>
				)}
			</div>
			{/* Footer here */}
		</div>
	)
}

export default Account
